module.exports = __webpack_public_path__ + "img/Campus-min.4a9d0fa5.jpg";